
enum Environments {
  'us-dit' = 'us-dit',
  'us-stage' = 'us-stage',
  'us-perf' = 'us-perf',
  'us-prod' = 'us-prod',
}

export const accountingARUrl: Record<Environments, string> = {
  'us-dit': 'https://bff-dms-accounting-receivables-bff.ext.nebula-dev.connectcdk.com',
  'us-perf': 'https://bff-dms-accounting-receivables-bff.ext.nebula-dev.connectcdk.com',
  'us-stage': 'https://bff-dms-accounting-receivables-bff.ext.nebula-dev.connectcdk.com',
  'us-prod': 'https://bff-dms-accounting-receivables-bff.ext.nebula.connectcdk.com', 
};

export const accountingARGroupUrl: Record<Environments, string> = {
  'us-dit': 'https://bff-dms-accounting-receivables-bff.ext.nebula-dev.connectcdk.com',
  'us-perf': 'https://bff-dms-accounting-receivables-bff.ext.nebula-dev.connectcdk.com',
  'us-stage': 'https://bff-dms-accounting-receivables-bff.ext.nebula-dev.connectcdk.com',
  'us-prod': 'https://bff-dms-accounting-receivables-bff.ext.nebula.connectcdk.com', 
};

export const accountingARAppLinkUrl: Record<Environments, string> = {
  'us-dit': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/accounts-receivable',
  'us-perf': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/accounts-receivable',
  'us-stage': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/accounts-receivable',
  'us-prod': 'https://driveworkflowmenu.connectcdk.com/accounting/accounts-receivable', 
};

export const accountingPOUrl: Record<Environments, string> = {
  'us-dit': 'https://bff-dms-accounting-purchase-order-bff.na-dev.connectcdk.com',
  'us-perf': 'https://bff-dms-accounting-purchase-order-bff.na-dev.connectcdk.com',
  'us-stage': 'https://bff-dms-accounting-purchase-order-bff.na-dev.connectcdk.com',
  'us-prod': 'https://bff-dms-accounting-purchase-order-bff.na.connectcdk.com', 
};

export const accountingGLUrl: Record<Environments, string> = {
  'us-dit': 'https://dms-accounting-gl-web-bff-jwt.na-dev.connectcdk.com',
  'us-perf': 'https://dms-accounting-gl-web-bff-jwt.na-dev.connectcdk.com',
  'us-stage': 'https://dms-accounting-gl-web-bff-jwt.na-dev.connectcdk.com',
  'us-prod': 'https://dms-accounting-gl-web-bff-jwt.na.connectcdk.com', 
};

export const accountingGLCommonUrl: Record<Environments, string> = {
  'us-dit': 'https://dms-ui-common-bff-jwt.na-dev.connectcdk.com',
  'us-perf': 'https://dms-ui-common-bff-jwt.na-dev.connectcdk.com',
  'us-stage': 'https://dms-ui-common-bff-jwt.na-dev.connectcdk.com',
  'us-prod': 'https://dms-ui-common-bff-jwt.na.connectcdk.com', 
};

export const accountingGLBalanceAppLinkCommonUrl: Record<Environments, string> = {
  'us-dit': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/gl-inquiry/account-balance',
  'us-perf': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/gl-inquiry/account-balance',
  'us-stage': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/gl-inquiry/account-balance',
  'us-prod': 'https://driveworkflowmenu.connectcdk.com/accounting/gl-inquiry/account-balance', 
};

export const accountingGLUnpostedAppLinkCommonUrl: Record<Environments, string> = {
  'us-dit': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/journal-entries/unposted-entries',
  'us-perf': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/journal-entries/unposted-entries',
  'us-stage': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/journal-entries/unposted-entries',
  'us-prod': 'https://driveworkflowmenu.connectcdk.com/accounting/journal-entries/unposted-entries', 
};

export const accountingPOAppLinkUrl: Record<Environments, string> = {
  'us-dit': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/purchase-order',
  'us-perf': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/purchase-order',
  'us-stage': 'https://app-dms-root-app.app-dev.connectcdk.com/accounting/purchase-order',
  'us-prod': 'https://driveworkflowmenu.connectcdk.com/accounting/purchase-order', 
};

export const commonAdminIdentityUrl: Record<Environments, string> = {
  'us-dit': 'https://identity-nginx.global-dit.connectcdk.com',
  'us-perf': 'https://identity-nginx.global-dit.connectcdk.com',
  'us-stage': 'https://identity-nginx.global-dit.connectcdk.com',
  'us-prod': 'https://identity-nginx.global.connectcdk.com', 
};

export const commonAdminLinkUrl: Record<Environments, string> = {
  'us-dit': 'https://admin-stage.connectcdk.com/enterprise',
  'us-perf': 'https://admin-stage.connectcdk.com/enterprise',
  'us-stage': 'https://admin-stage.connectcdk.com/enterprise',
  'us-prod': 'https://admin.connectcdk.com/enterprise', 
};

export const unitStockingLinkUrl: Record<Environments, string> = {
  'us-dit': 'https://app-unit-stocking.app-stage.connectcdk.com/dashboard',
  'us-perf': 'https://app-unit-stocking.app-stage.connectcdk.com/dashboard',
  'us-stage': 'https://app-unit-stocking.app-stage.connectcdk.com/dashboard',
  'us-prod': 'https://app-unit-stocking.app.connectcdk.com/dashboard', 
};


export const commonAdminAuthzUrl: Record<Environments, string> = {
  'us-dit': 'https://authz-nginx.global-dit.connectcdk.com',
  'us-perf': 'https://authz-nginx.global-dit.connectcdk.com',
  'us-stage': 'https://authz-nginx.global-dit.connectcdk.com',
  'us-prod': 'https://authz-nginx.global.connectcdk.com', 
};

